<template>
  <div class="wrap" v-bind:style="{
    backgroundImage: 'url(' + bg + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    position: 'relative'
  }">
    <div style="
                                      position: absolute;
                                      top: 0px;
                                      right: 0px;
                                      height: 64px;
                                      display: flex;
                                      align-items: center;
                                      color: #ffffff;
                                    ">
      <!-- <div class="systemIntroduction">系统介绍</div> -->
      <!-- <div class="appDownload" >APP下载</div> -->
      <div :style="{ marginRight: AppDownloadShow == false ? '0px' : '50px' }" class="nodeChange">
        <el-dropdown trigger="click" @command="changeNode" @visible-change="changeNodeValue">
          <span class="dropdown-trigger">
            <span style="margin-right: 10px">
              {{ nodeActive }}
            </span>
            <i v-if="this.serverNodeValue" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown">
            <el-dropdown-item v-for="item in serverNodeList" style="
                                              align-items: center;
                                              display: flex;
                                              padding: 3px 15px;
                                              font-size: 16px;
                                            " :command="item.url" :key="item.name">{{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="loadAppBox">
        <el-popover v-if="!isHaveApp && AppDownloadShow" popper-class="popoverApp" placement="bottom" trigger="hover">
          <!-- <img v-if="!icaApp" style="border: 1px dashed;width:150px;height:150px;" src="@/assets/img/appDownload.png" /> -->
          <div v-if="!icaApp" class="erweimabox">
            <!-- 手机扫码下载APP -->
            <span class="erweimatoptip">{{ $t("login.scan_download") }}</span>
            <div class="erweimacell">
              <!-- <img style="top: 116px;left: 221px;width:154px;height:150px;" src="@/assets/img/appDownload.png" /> -->
              <!-- <i style="font-size:150px;position:absolute;top:30px;left:22px;color:black;" class="iconfont icon-delete"></i> -->
              <span class="colorbox">
                <img src="@/assets/img/appDownloadMask.png" class="colorimg" />
              </span>
              <span class="erweimaline"></span>
            </div>
          </div>
          <div v-if="icaApp">
            <div :style="{ marginBottom: icaApp == true ? '10px' : '20px' }" class="appDownload">{{
              $t("login.scan_download")
            }}</div>
            <div style="display: flex">
              <div v-if="iosShow">
                <div>ios</div>
                <img style="border: 1px dashed; width: 150px; height: 150px" :src="iosBg" />
              </div>
              <div v-if="androidShow">
                <div>Android</div>
                <img style="border: 1px dashed; width: 150px; height: 150px" :src="androidBg" />
              </div>
            </div>

          </div>
          <div class="appDownload" slot="reference">
            {{ $t("login.app_download") }}
          </div>
        </el-popover>
        <div v-if="isHaveApp" class="downloadApp" @click="toDownload">{{ $t("login.app_download") }}</div>
      </div>
      <!-- 语言切换 -->
      <div class="languageSwitch">
        <el-dropdown trigger="hover" @command="changeLang" @visible-change="changeLangValue">
          <span class="dropdown-trigger">
            <span class="language">
              <!-- <img :src="imgurl" style="width:32px;height:24px;" /> -->
              <img :src=langActive.langSrc style="width: 18px; height: 18px; margin-right: 6px" />
              <!-- <i style="font-size:20px;" class="iconfont icon-zhongguo"></i> -->
              {{ langActive.lang }}
            </span>
            <!-- <i v-if="this.changeValue" class="el-icon-arrow-up"></i> -->
            <!-- <i v-else class="el-icon-arrow-down"></i> -->
            <!-- <span class="caret"></span> -->
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown">
            <el-dropdown-item v-for="item in langList" style="
                                              align-items: center;
                                              justify-content: start;
                                              display: flex;
                                              color: rgba(74, 75, 87, 1);
                                              width: 134px;
                                              height: 36px;
                                              line-height: 36px;
                                              font-family: Microsoft YaHei;
                                              font-size: 14px;
                                              padding-left: 10px;
                                            " :command="item.value" :key="item.name"
              :class="{ selected: currentLang == item.value }">

              <span>
                <img :src="item.imgurl" style="width:16px;height:16px;float: left;margin:0 15px 0 5px" />
              </span>
              <span>
                {{ item.name }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="UPlogo-pic">
      <img :src="logoUrl" class="logo-pic" />
    </div>
    <keep-alive :include="['login']">
      <component
        :XTechShow="XTechShow"
        :iosBg="iosBg"
        :iosShow="iosShow"
        :androidShow="androidShow"
        :androidBg="androidBg"
        :userInfo="userInfo"
        :is="mode"
        @changeMode="val => (mode = val)"
        @signupSuc="userInfo => handleSignupSuc(userInfo)"
      ></component>
    </keep-alive>
    <div class="caseBottom" v-if="currentLang == 'zh_CN' && filingShow">
      <!-- 原http://www.beian.miit.gov.cn -->
      <a class="case" href="https://beian.miit.gov.cn" target="_blank">粤ICP备14070077号-5</a>
      <!-- 原V2.0.1.5 -->
      <span class="version">V3.58.7.1</span>
    </div>
  </div>
</template>
<script>
import login from "./login"
import signup from "./signup"
import retrieve from "./retrieve"
import retrieveUser from "./retrieveUser"
import Store from "@/store";
import cookie from "@/assets/js/cookie"
// import beebeejump from "@/assets/img/beebeejump/logo.png";
// import tgpro from "@/assets/img/tgpro/logo.png";
import dessmonitorLogo from "@/assets/img/default/logo-pic.png";
import dessmonitorBg from "@/assets/img/bg.png";
// import dessmonitorBg from "@/assets/img/bggif.gif";
import dessmonitorAppIOSBg from "@/assets/img/pv123essapplestore.png";
import dessmonitorAppAndroidBg from "@/assets/img/pv123essgoogleplay.png";
import axios from "axios";
import config from '@/assets/js/config';
export default {
  components: {
    login,
    signup,
    retrieve,
    retrieveUser,
    axios
  },
  data() {
    return {
      serverNodeValue: false,
      serverNodeList: [],
      icaApp: false,
      tgpropowerApp: false,
      mode: "login",
      userInfo: null,
      changeValue: false,
      currentLang: this.$lang.currentLang,
      imgurl: "",
      logoUrl: "",
      bg: "",
      currentNode: "",
      filingShow: false,// 备案显隐
      AppDownloadShow: false,// APP下载显隐
      XTechShow: false,//洁源扫码显隐
      iosBg: null,
      androidBg: null,
      iosShow: false,//苹果下载显隐
      androidShow: false,//安卓下载显隐
      isHaveApp: false,
    }
  },
  created() {
    this.currentNode = cookie.getCookie("saveCurrentNode")
    // this.determineHost()
    this.checkDomainPass()
    this.getUserInfo()
    this.bbjEn()
    // this.getHostName()
    // cookie.delCookie("saveCurrentNode");
    this.$lang.langList.forEach(item => {
      if (item.value == this.$lang.currentLang) {
        this.imgurl = item.imgurl
      }
    })
    this.getDomainAPP()
  },
  mounted() {
    if(config.env =="production"){
      this.getServerNode1()
    }else{
      this.serverNodeList = [
         {
           name: this.$t("version.default_node"),
           url: ""
         }
      ]
    }
    this.$lang.langList.forEach(item => {
      if (item.value == this.$lang.currentLang) {
        this.imgurl = item.imgurl
      }
    })
  },
  computed: {
    nodeActive() {
      var node
      for (let i = 0; i < this.serverNodeList.length; i++) {
        if (this.serverNodeList[i].url == cookie.getCookie("saveCurrentNode")) {
          node = this.serverNodeList[i].name
          break
        } else {
          node = this.$t("version.default_node")
        }
      }
      return node
    },

    langList() {
      var hostname = window.location.hostname
      var langList = []
      //比比赞定制只有英文
      if (hostname == "beebeejump.dessmonitor.com") {
        langList.push(this.$lang.langList[0])
        return langList
      } else if (hostname == "lshe.dessmonitor.com") {
        //利星行新增两个语言【德语/意大利语】其他域名下不显示这两种语言
        langList.push(this.$lang.langList[0])
        langList.push(this.$lang.langList[1])
        langList.push(this.$lang.langList[2])
        langList.push(this.$lang.langList[3])
        langList.push(this.$lang.langList[4])
        langList.push(this.$lang.langList[5])
        return langList
      } else if (hostname == "x-tech.dessmonitor.com") {
        //山东洁源新增两【德语】
        langList.push(this.$lang.langList[0])
        langList.push(this.$lang.langList[1])
        langList.push(this.$lang.langList[2])
        langList.push(this.$lang.langList[4])
        return langList
      } else if (hostname == "energon.dessmonitor.com") {
        langList.push(this.$lang.langList[0])
        langList.push(this.$lang.langList[1])
        langList.push(this.$lang.langList[2])
        langList.push(this.$lang.langList[5])
        langList.push(this.$lang.langList[6])
        langList.push(this.$lang.langList[7])
        langList.push(this.$lang.langList[8])
        return langList
      } else {
        langList.push(this.$lang.langList[0])
        langList.push(this.$lang.langList[1])
        langList.push(this.$lang.langList[2])
        langList.push(this.$lang.langList[4])
        langList.push(this.$lang.langList[5])
        langList.push(this.$lang.langList[9])
        langList.push(this.$lang.langList[10])
        langList.push(this.$lang.langList[11])
        // langList.push(this.$lang.langList[12])
        return langList
      }
    },
    langActive() {
      var lang
      var langSrc
      this.$lang.langList.forEach(element => {
        if (element.value == this.$lang.currentLang) {
          lang = element.name
          langSrc = element.imgurl
        }
      })
      return {
        lang,
        langSrc
      }
    }
  },
  methods: {
    checkDomainPass() {
      var _this = this
      let DomainNameStr = window.document.location.hostname;
      // let host = window.location.hostname.split(".")[0];
      //let host = window.location.hostname;
      let domainName = window.location.hostname;
      // let regex=/^[a-zA-Z0-9-]+\.(dessmonitor\.com)$/;
      // if (!regex.test(DomainNameStr)) {
      // var DomainNameIMG = new Image()
      // DomainNameIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.png"
      // DomainNameIMG.onload = function () {
      //   _this.logoUrl = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.png"
      //   _this.bg = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/background.png"
      // }
      // DomainNameIMG.onerror = function () {
      //   _this.bg = dessmonitorBg
      //   _this.logoUrl = dessmonitorLogo
      // }
      // }else{
      let params = {
        domainName: domainName
      }
      let action = '/hmi/api/hmi/domain/check/shineOrDess/auth/checkDomainPass/' + 2
      _this.$request.getHMI(action, params).then(res => {
        if (res.code == 0) {
          if (res.data.background) {
            _this.bg = res.data.background
          } else {
            _this.bg = dessmonitorBg
          }
          if (res.data.sysLogo) {
            _this.logoUrl = res.data.sysLogo
          } else {
            _this.logoUrl = dessmonitorLogo
          }
        } else {
          _this.bg = dessmonitorBg
          _this.logoUrl = dessmonitorLogo
        }
      }).catch(e => {
        _this.bg = dessmonitorBg
        _this.logoUrl = dessmonitorLogo
      })
      // }
      _this.iosBg = dessmonitorAppIOSBg
      _this.androidBg = dessmonitorAppAndroidBg
      var DomainNameIOSIMG = new Image()
      var DomainNameAndroidIMG = new Image()
      DomainNameIOSIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/" + DomainNameStr.replace(/\./g, '') + "/ios.png"
      DomainNameAndroidIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/" + DomainNameStr.replace(/\./g, '') + "/android.png"
      DomainNameIOSIMG.onload = function () {
        _this.AppDownloadShow = true
        _this.XTechShow = true
        _this.iosShow = true
        _this.iosBg = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/" + DomainNameStr.replace(/\./g, '') + "/ios.png"
      }
      DomainNameAndroidIMG.onload = function () {
        _this.AppDownloadShow = true
        _this.XTechShow = true
        _this.androidShow = true
        _this.androidBg = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/" + DomainNameStr.replace(/\./g, '') + "/android.png"
      }
      if (!_this.androidShow && !_this.iosShow) {
        _this.AppDownloadShow = false
      }
      DomainNameAndroidIMG.onerror = function () {
      }
      DomainNameIOSIMG.onerror = function () {
      }
      _this.getHostName()
    },
    changeNode(currentNode) {
      this.currentNode = currentNode
      cookie.setCookie("saveCurrentNode", currentNode)
      window.location.reload() //刷新页面
    },
    changeNodeValue(nodeValue) {
      this.serverNodeValue = nodeValue
    },
    //获取节点
    getServerNode1() {
      let param = {
        source: 1,
        _app_client_: "web",
        _app_id_: window.location.hostname,
        _app_version_: "1.0.6.3",
        i18n: this.$lang.currentLang
      }
      this.serverNodeList = []
      this.$request
        .get1("queryDomainListNotLogin", param)
        .then(res => {
          if (res.err == 0) {
            if (res.dat.length != 0) {
              res.dat.map(element => {
                this.serverNodeList.push({
                  name: element.name,
                  url: element.url
                })
              })
            } else {
              this.serverNodeList = [
                {
                  name: this.$t("version.default_node"),
                  url: ""
                }
              ]
            }
          } else {
            this.serverNodeList = [
              {
                name: this.$t("version.default_node"),
                url: ""
              }
            ]
          }
        })
        .catch(() => {
          this.serverNodeList = [
            {
              name: this.$t("version.default_node"),
              url: ""
            }
          ]
        })
    },
    //判断域名修改logo
    // determineHost() {
    //   this.logoUrl = ''
    //   this.bg = ''
    //   this.iosBg = dessmonitorAppIOSBg
    //   this.androidBg = dessmonitorAppAndroidBg
    //   let DomainNameStr = window.document.location.hostname;
    //   var DomainNameIMG = new Image()
    //   var DomainNameIOSIMG = new Image()
    //   var DomainNameAndroidIMG = new Image()
    //   var _this = this
    //   DomainNameIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.png"
    //   DomainNameIOSIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/ios.png"
    //   DomainNameAndroidIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/android.png"
    //   DomainNameIMG.onload = function () {
    //     _this.logoUrl = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.png"
    //     _this.bg = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/background.png"
    //   }
    //   DomainNameIOSIMG.onload = function () {
    //     _this.AppDownloadShow = true
    //     _this.XTechShow=true
    //     _this.iosShow = true
    //     _this.iosBg = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/ios.png"
    //   }
    //   DomainNameAndroidIMG.onload = function () {
    //     _this.AppDownloadShow = true
    //     _this.XTechShow=true
    //     _this.androidShow = true
    //     _this.androidBg = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/android.png"
    //   }
    //   if (!_this.androidShow&&!_this.iosShow) {
    //     _this.AppDownloadShow = false
    //   }
    //   DomainNameIMG.onerror = function () {
    //     _this.bg = dessmonitorBg
    //     _this.logoUrl = dessmonitorLogo
    //   }
    //   DomainNameAndroidIMG.onerror = function () {
    //   }
    //   _this.getHostName()
    // },
    //比比赞定制只有英文
    bbjEn() {
      var hostname = window.location.hostname
      if (hostname == "beebeejump.dessmonitor.com" && this.$lang.currentLang != "en_US") {
        this.$lang.currentLang = "en_US"
      }else if(hostname == "eg4.dessmonitor.com" && this.$lang.currentLang != "en_US"){
        this.$lang.currentLang = "en_US"
      }else if((hostname == "cloud.fox-power.com"||hostname == "foxpower.dessmonitor.com") && this.$lang.currentLang != "en_US"){
        this.$lang.currentLang = "en_US"
      }else if(hostname == "x-tech.dessmonitor.com" && this.$lang.currentLang != "en_US"){
        this.$lang.currentLang = "en_US"
      }else if(hostname == "energon.dessmonitor.com" && this.$lang.currentLang != "en_US"){
        this.$lang.currentLang = "en_US"
      }else if((hostname == "monitoring2.icasolar.com"||hostname == "icasolar.dessmonitor.com")  && this.$lang.currentLang != "en_US"){
        this.$lang.currentLang = "en_US"
      }
    },
    //标准定制功能显隐
    getHostName() {
      var hostname = window.location.hostname
      if (!this.AppDownloadShow) {
        if (hostname == "www.dessmonitor.com" || hostname == "ess.dev.eybond.com" || hostname == "ess.test.eybond.com") {
          this.filingShow = true
          this.AppDownloadShow = true
        } else if (hostname == "tgpropower.dessmonitor.com") {
          this.filingShow = false
          this.AppDownloadShow = true
        } else if (hostname == "monitoring2.icasolar.com") {
          this.iosShow = true
          this.androidShow = true
          this.icaApp = true
          this.filingShow = false
          this.AppDownloadShow = true
        } else {
          this.icaApp = true
          this.filingShow = false
          this.AppDownloadShow = false
        }
      }

      //根据域名判断主题
      if (hostname.indexOf("poweringev") != -1) {
        localStorage.setItem("theme", "YWY-light")
      } else {
        localStorage.setItem("theme", "default-light")
      }
    },
    // 切换语言
    changeLang(currentLang) {
      this.$lang.currentLang = currentLang
    },
    changeLangValue(changeValue) {
      // console.log('changeValue',changeValue)
      this.changeValue = changeValue
    },
    // 注册成功
    handleSignupSuc(userInfo) {
      this.userInfo = userInfo
      this.mode = "login"
    },
    // 记住密码时获取用户信息
    getUserInfo() {
      let userInfo = cookie.getCookie("userInfo")
      if (userInfo) {
        // this.userInfo = { ...JSON.parse(userInfo), isRem: true }
        this.userInfo = { ...JSON.parse(userInfo)}
      }
    },
    // 跳转下载APP
    toDownload() {
      if (config.env === 'development' || config.env === 'test') {
        window.open(`http://test.eybond.com:9167/applist?domain=${window.location.hostname}&i18n=${this.$lang.currentLang}`, "_blank")
      } else if (config.env === 'production') {
        window.open(`https://aam.eybond.com/applist?domain=${window.location.hostname}&i18n=${this.$lang.currentLang}`, "_blank");
      }
    },
    // 查询当前域名是否有对应APP
    getDomainAPP() {
      let hostName = window.location.hostname;
      if (window.location.hostname.indexOf(':') != -1) {
        hostName = window.location.hostname.split(':')[0];
      }
      this.$request.getAAM('queryDomainApp', this.$lang.currentLang, hostName).then(res => {
        if (res.err == 0) {
          this.isHaveApp = true
        }
      })
    }
  }
}
</script>

<style lang="less">
@import url("../../assets/css/mixin");

.entry {
  margin-top: 14.97vh;
  position: relative;
  box-shadow: 0px 6px 54px rgba(0, 23, 4, 0.6);
  display: flex;
  background: #ffffff;
  flex-direction: column;
  border-radius: 10px;
  width: 526px;
  height: 530px;
  padding: 0px 80px 0px 80px;

  .top {
    display: flex;
    // line-height: 10px;
    flex-direction: row;
    // align-items: center;
    width: 366px;

    .logo {
      position: absolute;
      top: 8px;
      right: 8px;
      font-size: 60px;
      // width:60px;
      height: 60px;
      background: rgba(255, 255, 255, 0);
      line-height: 60px;
      // border-radius:10px;
      cursor: pointer;
    }
  }

  .erweima {
    margin-top: 36px;

    img {
      // display: block;
      margin: 0 auto;
    }
  }

  .submit-container {
    margin-top: 2px;

    .login-solid {
      width: 366px;
      height: 45px;
      color: #ffffff;
      background: #1890ff;
      border: #1890ff;
      font-weight: bold;
      border-radius: 4px;

      &:hover,
      &:focus {
        background: #40a9ff;
        border: #1890ff;
      }

      &:active {
        background: #096dd9;
        border: #096dd9;
      }

      .loginName {
        width: 52px;
        height: 19px;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        line-height: 19px;
      }
    }
  }

  .info {
    font-size: 18px;
    color: #333;
    line-height: 40px;
    text-align: center;

    .link {
      padding: 0 5px;
      color: @themeColor;
      cursor: pointer;
    }
  }

  .el-form-item {
    &:not(:last-child) {
      margin-bottom: 24px;
    }

    .el-form-item__content {
      line-height: normal;
    }
  }

  .el-input {
    font-size: 16px;
    color: #ffffff;

    .el-input__inner {
      border-radius: 4px;
      height: 45px;
      background: #fff;
      line-height: 45px;
      padding: 0px 35px 0px 50px;
      // &:focus {
      //   border-color: yellow;
      // }
    }
  }

.clear_pwd .el-input__inner {
  padding-right: 64px !important; // 32+32，保证两个按钮都不遮挡内容
}
}

.el-popover.popoverApp {
  text-align: center;
  top: 48px;
  left: 194px;
  height: 251px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: 15px;
}

.el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}

.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  display: none;
}

.el-popper {
  .erweimabox {
    margin-top: 6px;

    .erweimatoptip {
      display: block;
      top: 68px;
      left: 210px;
      // width: 119px;
      width: 100%;
      text-align: left;
      height: 20px;
      // background: rgba(74, 75, 87, 1);
      color: rgba(74, 75, 87, 1);
      font-family: Microsoft YaHei;
      font-size: 15px;
    }

    .erweimacell {
      // position: relative;
      top: 103px;
      left: 210px;
      width: 176px;
      height: 176px;
      border-radius: 2px;
      background: rgba(234, 239, 243, 1);
      padding: 14px 0 0;
      margin-top: 15px;
      // overflow: hidden;
      background: url(../../assets/img/appDownload.png) center center no-repeat rgba(234, 239, 243, 1);

      .colorbox {
        display: block;
        top: 268px;
        // left: 211px;
        // width: 175px;
        height: 300px;
        overflow: hidden;
        padding-bottom: 5px;

        animation: movemask 3s ease-in-out infinite;
        -webkit-animation: movemask 3s ease-in-out infinite;

        // &::before{
        //   content: '';
        //   display: block;
        //   position: absolute;
        //   left: 0;
        //   bottom: 5px;
        //   width: 175px;
        //   height: 6px;
        //   border-radius: 3px;
        //   background: rgba(9, 107, 255, 1);
        //   box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 5px rgba(8, 107, 255, 0.6);
        // }
        .colorimg {
          position: absolute;
          top: -1px;
          left: 11px;
          width: 154px;
          height: 150px;

          animation: moveimg 3s ease-in-out infinite;
          -webkit-animation: moveimg 3s ease-in-out infinite;
        }
      }

      .erweimaline {
        display: block;
        bottom: 5px;
        left: 1px;
        width: 175px;
        height: 6px;
        border-radius: 3px;
        background: rgba(9, 107, 255, 1);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 5px rgba(8, 107, 255, 0.6);

        animation: moveline 3s ease-in-out infinite;
        -webkit-animation: moveline 3s ease-in-out infinite;
      }
    }
  }
}

// .el-popover.popoverApp:hover {
//   .appDownload {
//     background-color: rgb(4, 100, 200);
//   }
// }
// @-webkit-keyframes
@keyframes movemask {
  0% {
    transform: translateY(-302px);
  }

  50% {
    transform: translateY(-142px);
  }

  100% {
    transform: translateY(-302px);
  }
}

@keyframes moveimg {
  0% {
    transform: translateY(302px);
  }

  50% {
    transform: translateY(142px);
  }

  100% {
    transform: translateY(302px);
  }
}

@keyframes moveline {
  0% {
    transform: translateY(-310px);
  }

  50% {
    transform: translateY(-150px);
  }

  100% {
    transform: translateY(-310px);
  }
}
</style>

<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

.dropdown {
  overflow: hidden;
  background: #fff;
  border-radius: 6px;
  border: none;
}

.el-dropdown-menu {
  background-color: #fff;
  color: #999;
  border: 1px solid #ebeef5;
}

.el-dropdown-menu .el-dropdown-menu__item {
  color: #999;
}

.el-dropdown-menu .el-dropdown-menu__item:not(:last-child) {
  border-bottom: 1px solid #f2f2f2;
}

.el-dropdown-menu .el-dropdown-menu__item:not(:first-child) {
  border-top: none;
}

.el-dropdown-menu .el-dropdown-menu__item:hover,
.el-dropdown-menu .el-dropdown-menu__item:focus {
  background-color: rgba(242, 242, 242, 0.8);
  color: #999;
}

.wrap {
  /* background: url(../../assets/img/bg.png) center center no-repeat; */
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  // position: relative;
  background-size: 100% 100%;
  height: 100%;
  // position: fixed;
  // top: 0;
  // bottom: 0;
  // right: 0;
  // left: 0;

  .nodeChange {

    height: 44px;
    line-height: 44px;
    padding: 0 5px;
    border-radius: 5px;
    cursor: pointer;

    .dropdown-trigger {
      font-size: 16px;
      color: #fff;

    }
  }

  .nodeChange:hover {
    background: rgba(255, 255, 255, .25);
  }

  .languageSwitch {
    height: 44px;
    line-height: 44px;
    margin-right: 45px;
    margin-left: 40px;
    // background-color: transparent;
    border-radius: 6px;

    &:hover {
      background: rgba(255, 255, 255, .25)
    }

    .dropdown-trigger {
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 16px;
      cursor: pointer;

      .language {
        // .sc(16px, #333);
        // margin-right: 8px;
        justify-content: space-between;
        align-items: center;
        display: flex;
        // width: 76px;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
        font-size: 16px;
        padding: 0 10px;
      }

      // .caret {
      //   width: 0;
      //   height: 0;
      //   border-top: 7px solid #ccc;
      //   border-left: 7px solid transparent;
      //   border-right: 7px solid transparent;
      // }
    }
  }

  .systemIntroduction,
  .appDownload {
    // padding: 0 16px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    background-color: transparent;
    font-size: 16px;
    padding: 0 10px;

    // &:hover {
    //   border-bottom: 2px solid #ffffff;
    // }
  }

  .loadAppBox {
    margin-left: 40px;
  }

  .loadAppBox:hover {
    .appDownload {
      background: rgba(255, 255, 255, .25)
    }
  }

  .UPlogo-pic {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 256px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo-pic {
      width: 210px;
      height: 48px;
    }
  }

  .caseBottom {
    //页面高度缩小时版本号隐藏
    // z-index: -1;
    position: absolute;
    bottom: 4%;
    // bottom: 125px;
    left: 50%;
    transform: translateX(-50%);

    .case {
      font-size: 12px;
      color: #ffffff;
      opacity: 0.85;

      &:hover {
        text-decoration: underline;
      }
    }

    .version {
      margin-left: 10px;
      font-size: 12px;
      color: #fff;
    }
  }
}

.downloadApp {
  font-size: 16px;
  cursor: pointer;
  // margin-left: 40px;
  line-height: 44px;
  border-radius: 10%;
  padding: 0 8px;
}

.downloadApp:hover {
  background-color: rgba(255, 255, 255, 0.25);
}
</style>
